export default __webpack_public_path__ + "static/media/92859965-fd43-4da4-9129-655fc1be5b28.0e60576c.jpg";